export const trafficStarsTemplateDataId = "exoclick-before-pagination-sol"
export const trafficStarsMobilePaginationSpot = "79272d962118415b8971938cffe03730"
export const trafficStarsMobilePaginationTemplateId = 12

export const trafficStarsBeforePaginationHtmlMobile = `<section id="page-top-sol" class="page-stripe page-stripe-page-top-sol page-stripe-content-traffic-stars page-stripe-content-traffic-stars-mobile no-solads-label extra-top-spacing" data-traffic-stars-id="${trafficStarsTemplateDataId}">
    <div class="container">
        <div class="row-page-actions-sol base-row row">
            <div class="sol-content uncensored-banner relative text-left content-width-320">
                <div class="sol-advert-mark">
                    <span class="sol-label"><a href="https://trafficstars.com/" target="_blank" rel="nofollow">TrafficStars</a></span>
                    <small class="sol-text-label">Anzeige</small>
                </div>

                <div class="sol-frame sol-type-display uncensored-banner-container"></div>
            </div>
        </div>
    </div>
</section>`

export const trafficStarsMsJsSrc = "//cdn.tsyndicate.com/sdk/v1/ms.js"

export function injectTrafficStarsScript(
    container: Element,
    spot: string,
    templateId: number,
    categories = "{categories}",
    subid = "{subid}",
): void {
    const script = document.createElement("script")
    script.src = trafficStarsMsJsSrc
    script.setAttribute("data-ts-spot", spot)
    script.setAttribute("data-ts-template-id", String(templateId))
    script.setAttribute("data-ts-categories", categories)
    script.setAttribute("data-ts-subid", subid)
    script.async = true
    script.defer = true
    container.appendChild(script)
}

export const trafficStarsPcPaginationSpot = "25dfc8bcea6e4dca848d849f2beeb8c2"
export const trafficStarsPcPaginationTemplateId = 3

export const trafficStarsGalleryClosingExplicitSpot = "578e6e2d539a4d2ca4f42fd230a11ea8"
export const trafficStarsGalleryClosingStandardSpot = "f101f7a7cfdc44eba82e9a7924ef4058"
export const trafficStarsGalleryClosingTemplateId = 10

export const trafficStarsBeforePaginationHtmlPc =
    () => `<div class="page-stripe-traffic-stars-pagination page-stripe-content-traffic-stars" data-traffic-stars-id="${trafficStarsTemplateDataId}">
    <div class="item clearfix text-left">
        <div class="sol-content uncensored-banner relative col-xs-12 content-width-240">
            <div class="sol-advert-mark">
                <span class="sol-label">
                    <a href="https://trafficstars.com/" target="_blank" rel="nofollow">TrafficStars</a>
                </span>
                <small class="sol-text-label">Anzeige</small>
            </div>
            <div class="sol-frame sol-type-display uncensored-banner-container" data-columns="2"></div>
        </div>
    </div>
</div>`

export const trafficStarsBottomPc = `<section class="page-stripe page-stripe-content-solads page-stripe-content-traffic-stars white no-top-spacing no-bottom-spacing traffic-stars-bottom">
    <div class="container">
        <div class="row">
                <div class="row service-sol">
                    <div class="sol-content uncensored-banner col-xs-12">
                        <div class="sol-advert-mark">
                            <span class="sol-label"><a href="https://trafficstars.com/" target="_blank" rel="nofollow">TrafficStars</a></span>
                            <small class="sol-text-label">Anzeige</small>
                        </div>

                        <div class="sol-frame sol-type-display uncensored-banner-container">
                            <script src="//cdn.tsyndicate.com/sdk/v1/ms.js"
                                data-ts-spot="25dfc8bcea6e4dca848d849f2beeb8c2"
                                data-ts-template-id="3"
                                data-ts-categories="{categories}"
                                data-ts-subid="{subid}"
                                async defer></script>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</section>`
